import { SignInButton, useAuth } from "@clerk/react";

const signInOnlyProps = {
  mode: "modal" as const,
  withSignUp: false,
  appearance: {
    elements: {
      footerAction: { display: "none" },
    },
  },
};

export default function Login() {
  const { isLoaded, isSignedIn } = useAuth();

  return (
    <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Sign in to SHE
          </h2>
          <p className="mt-2 text-center text-sm text-gray-500">
            Use your organization SSO account
          </p>
        </div>
        <div className="mt-8 flex flex-col items-center gap-3">
          {isLoaded && !isSignedIn && (
            <SignInButton {...signInOnlyProps}>
              <button
                type="button"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-yellow-600 py-2 px-4 text-sm font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
              >
                Sign in with SSO
              </button>
            </SignInButton>
          )}
        </div>
      </div>
    </div>
  );
}
